import type { KeyboardEvent } from 'react';

export function handleKeyDown<T = HTMLElement>(callback: (ev: KeyboardEvent<T>) => void) {
  return function _handleKeyDown(ev: KeyboardEvent<T>) {
    if (ev.key === 'Enter' || ev.key === ' ') {
      callback(ev);
    }
  };
}
